export default __webpack_public_path__ + "static/media/enactLogo.b1b7e719.svg";